import { HawaPanel } from '../types'
import component from './gauge-component.vue'
import editor from './gauge-editor.vue'
export default class GaugeObject implements HawaPanel {
  name = 'GaugeObject'
  title = 'Gauge Object'
  component = component
  editor = editor

  snapshot = {
    title: 'Gauge Object',
    attributes: {
      panelContent: {
        style: {},
      },
      cyclicUpdate: false,
      headerAlign: 'center',
      headerBackground: 'rgb(255,255,255)',
      headerForeground: 'rgb(0,0,0)',
      headerShow: false,
      rowEvenBackground: 'rgb(0,0,0)',
      rowOddBackground: 'rgb(0,0,0)',
      updateInterval: '3000',
      unit: '',
      tag: '',
    },
    data: null,
    layout: { i: '1591166209124', h: 24, w: 24, x: 0, y: 0, moved: false },
    query: [],
    options: {
      series: [
        {
          name: 'name',
          type: 'gauge',
          radius: '100%',
          min: 0,
          max: 100,
          splitNumber: 5,
          axisLine: {
            lineStyle: {
              width: 3,
              color: [
                [0.11, 'rgb(240, 175, 36)'],
                [0.83, 'rgb(73, 172, 43)'],
                [0.94, 'rgb(240, 175, 36)'],
                [1, 'red'],
              ],
            },
          },
          axisLabel: {
            textStyle: {
              fontSize: 5,
            },
            distance: 5,
            color: '',
            width: 1,
          },
          axisTick: {
            length: 6,
            lineStyle: {
              color: 'auto',
            },
          },
          splitLine: {
            length: 6,
            lineStyle: {
              color: 'auto',
              width: 2,
            },
          },
          pointer: {
            width: 2,
            length: '70',
          },
          detail: {
            formatter: function(value: number) {
              return value.toFixed(2)
            },
            offsetCenter: [0, '80%'],
            shadowBlur: 5,
            textStyle: {
              fontWeight: 'bolder',
              // color: '#fff',
              fontSize: 9,
            },
          },
          data: [{ value: 50, name: '' }],
        },
      ],
    },
  }
  init = {
    attributes: {
      panelHeader: {
        show: false,
        style: {},
      },
      panelContent: {
        style: {},
      },
      cyclicUpdate: false,
      headerAlign: 'center',
      headerBackground: 'rgb(255,255,255)',
      headerForeground: 'rgb(0,0,0)',
      headerShow: true,
      rowEvenBackground: 'rgb(0,0,0)',
      rowOddBackground: 'rgb(0,0,0)',
      showHeader: true,
      updateInterval: '3000',
      unit: '',
      tag: '',

      chartOptions: {
        series: [
          {
            name: 'name',
            type: 'gauge',
            radius: '100%',
            min: 10,
            max: 100,
            splitNumber: 5,
            axisLine: {
              lineStyle: {
                width: 8,
                color: [
                  [0.11, 'rgb(240, 175, 36)'],
                  [0.83, 'rgb(73, 172, 43)'],
                  [0.94, 'rgb(240, 175, 36)'],
                  [1, 'red'],
                ],
              },
            },
            axisLabel: {
              textStyle: {
                fontSize: 14,
              },
              distance: 5,
              color: '',
            },
            axisTick: {
              length: 11,
              lineStyle: {
                color: 'auto',
              },
              width: 1,
            },
            splitLine: {
              length: 18,
              lineStyle: {
                color: 'auto',
              },
              width: 2,
            },
            pointer: {
              width: 5,
              length: '90%',
            },
            title: {
              offsetCenter: [0, '-30%'],
              textStyle: {
                fontWeight: 'bolder',
                fontSize: 14,
                color: 'black',
              },
            },
            detail: {
              formatter: '{value} %',
              shadowBlur: 5,
              offsetCenter: [0, '70%'],
              textStyle: {
                fontWeight: 'bolder',
                color: 'auto',
                fontSize: 16,
              },
            },

            data: [
              {
                value: 23,
                name: '',
              },
            ],
          },
        ],
      },
      query: [],
    },
    data: null,
    layout: { i: '1591166209124', h: 24, w: 140, x: 0, y: 0, moved: false },
    query: [],
  }
}
